import { Component, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { SharedDsnModule } from "@app/shared/modules/shared-dsn.module";
import { SharedMaterialModule } from "@app/shared/modules/shared-material.module";
import { CompanyEntity } from "@arch/domain/entity";
import { RequestProductGrowthController } from "@arch/presentation/controllers/request-product-growth.controller";
import { ContactService } from "@app/shared/services/contact.service";
import { MatSnackBar } from "@angular/material/snack-bar";

@Component({
    selector: "app-request-product-growth",
    imports: [SharedMaterialModule, SharedDsnModule],
    templateUrl: "./request-product-growth.component.html",
    styleUrl: "./request-product-growth.component.scss"
})
export class RequestProductGrowthComponent {
    private readonly dialogRef = inject(
        MatDialogRef<RequestProductGrowthComponent>
    );
    public readonly data = inject(MAT_DIALOG_DATA) as RequestProductGrowthData;
    private readonly requestProductGrowthController = inject(
        RequestProductGrowthController
    );
    private readonly contactService = inject(ContactService);
    private readonly snackBar = inject(MatSnackBar);
    public onRequestProductGrowth(): void {
        const contact = this.contactService.get();
        this.dialogRef.close(true);
        this.snackBar.open("Solicitação enviada com sucesso", "Fechar", {
            duration: 3000
        });
        this.requestProductGrowthController.execute({
            accountingId: this.data.company.props.accounting._id,
            package: this.data.package,
            licenses: this.data.licenses,
            email: contact.props.email,
            options: this.data.options
        });
    }

    public onClose(): void {
        this.dialogRef.close(false);
    }
}

type RequestProductGrowthData = {
    title: string;
    imageSrc: string;
    subtitle: string;
    description: string;
    hint: string;
    cta: string;
    company: CompanyEntity;
    package:
        | "Chat da IA do Contador"
        | "Atalhos da IA do Contador"
        | "Chat da IA do Empresário"
        | "Análise Plus";
    licenses: number;
    options: {
        addedValue: string;
        period: string;
    };
};
